import React, { useState } from 'react'
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
function EmpAttendanceReport() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const [reportType, setReportType] = useState(null)
    const [fromdate, setFromdate] = useState('')
    const [todate, setTodate] = useState('')
    const [loader, setLoader] = useState(false)
    const HandleReportType = (status) => {
        setReportType(status)
    }

    const Download_attendance_report = async () => {
        // alert(reportType)
        if (reportType == 3) {

            if (fromdate == '' || todate == '') {
                alert(fromdate);
                alert(todate);
            } else {
                setLoader(true)
                calcBusinessDays(fromdate, todate)
                fetch(SERVER_URL + `api/reports/customereport?fromdate=${fromdate}&&todate=${todate}`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                }).then(res => res.json())
                    .then(data => {

                        if (data?.results?.length > 0) {
                            const newArray = [
                                ['Attendance In/Out Details'],
                                ['', '', '', ''],
                                ['Company Name : Q2a Media services pvt ltd'],
                                ['', '', '', ''],
                                [`From Date: ${fromdate} To Date: ${todate}`],
                                [],
                                ['Employee Code', 'Employee Name', 'Company Name', 'Branch Name', 'Department Name', 'Date Of Joining'],
                                ['', '', '', '', '', '']
                            ];

                            let startDate = moment(fromdate);
                            let endDate = moment(todate);
                            const dateHeaders = [];

                            for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                                const formattedDate = m.format('YYYY-MM-DD');  // Date in 'YYYY-MM-DD' format
                                const dayOfWeek = m.format('dddd');  // Day of the week (e.g., Monday, Tuesday, etc.)
                                dateHeaders.push(`${dayOfWeek}, ${formattedDate}`);
                            }
                            // console.log('dateHeaders',dateHeaders)

                            newArray[6] = newArray[6].concat(dateHeaders.map(date => [`${date}`, ``, ``]).flat());
                            newArray[7] = newArray[7].concat(dateHeaders.map(date => [`In Time`, `Out Time`, `Total HRS`]).flat());
                            newArray[7] = newArray[7].concat(['Hours completed']);
                            newArray[7] = newArray[7].concat(['Total working days in Month']);
                            newArray[7] = newArray[7].concat(['Working day']);
                            newArray[7] = newArray[7].concat(['Leaves']);
                            newArray[7] = newArray[7].concat(['Hours require']);
                            newArray[7] = newArray[7].concat(['Shortfall hours']);
                            newArray[7] = newArray[7].concat(['Extra hours']);

                            function convertMinutesToHoursAndMinutes(totalMinutes) {
                                const HRS = Math.floor(totalMinutes / 60); // Calculate full hours
                                const minutes = totalMinutes % 60; // Remaining minutes
                                return `${HRS ? HRS : '00'}:${minutes ? minutes : '00'}`;
                            }
                            // Create an array of promises

                            const promises = data.results.map((getResult_data) => {


                                return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'authorization': `bearer ${token.value}`
                                    },
                                }).then(res => res.json())
                                    .then(res_data => {


                                        const temp_att = [
                                            getResult_data.user_code,
                                            getResult_data.name,
                                            getResult_data.cmp_name,
                                            'Noida',
                                            getResult_data.deptName,
                                            moment(getResult_data.joining_date).format('DD,MMM YYYY')
                                        ];



                                        let startDate = moment(fromdate);
                                        let endDate = moment(todate);

                                        let total_working_hrs = 0
                                        let total_working_days = 0
                                        for (let m = moment(startDate); m.isSameOrBefore(endDate); m.add(1, 'days')) {
                                            const isObjectPresent = res_data.results.find((o) =>
                                                moment(o.att_date).format('YYYY-MM-DD') === m.format('YYYY-MM-DD')
                                            );

                                            if (isObjectPresent) {
                                                temp_att.push(isObjectPresent.start_time);
                                                temp_att.push(isObjectPresent.end_time);
                                                temp_att.push(convertMinutesToHoursAndMinutes(isObjectPresent.TOTALDAYSMINUTS));


                                                total_working_hrs = total_working_hrs + isObjectPresent.TOTALDAYSMINUTS

                                                total_working_days = total_working_days + 1
                                                // temp_att.push(m.format('YYYY-MM-DD'))
                                            } else {
                                                temp_att.push('');
                                                temp_att.push('');
                                                temp_att.push('');
                                                // temp_att.push(m.format('YYYY-MM-DD'))
                                            }
                                        }


                                        temp_att.push(convertMinutesToHoursAndMinutes(total_working_hrs))
                                        temp_att.push(totalBusinessDays)
                                        temp_att.push(total_working_days)


                                        // get emp leave


                                        // return fetch(SERVER_URL + `api/reports/userattendence?userId=${getResult_data.id}&&fromdate=${fromdate}&&todate=${todate}`, {
                                        //     method: 'GET',
                                        //     headers: {
                                        //         'Accept': 'application/json',
                                        //         'Content-Type': 'application/json',
                                        //         'authorization': `bearer ${token.value}`
                                        //     },
                                        // }).then(res => res.json())
                                        //     .then(res_data => {

                                        //     })


                                        // get emp leave

                                        temp_att.push('')
                                        temp_att.push(total_working_days * 8)
                                        // console.log(temp_att)
                                        //return false




                                        return temp_att;
                                    });
                            });

                            // Wait for all promises to complete
                            Promise.all(promises).then((results) => {
                                results.forEach((temp_att) => {
                                    newArray.push(temp_att);
                                });

                                // console.log('newArray=>', newArray); // Access after all fetch calls are complete



                                //Generate Excel report
                                XlsxPopulate.fromBlankAsync()
                                    .then((workbook) => {
                                        const sheet = workbook.sheet(0);
                                        var setcolumn = 4
                                        var setcolumnRow7 = 1


                                        const mergeCellsInRow = (rowNumber, startColumn, endColumn) => {
                                            if (startColumn < 1 || endColumn < 1) {
                                                console.error("Column numbers must be 1 or greater.");
                                                return;
                                            }
                                            if (startColumn >= endColumn) {
                                                console.error(`Invalid merge range: Start (${startColumn}) must be less than End (${endColumn}).`);
                                                return;
                                            }

                                            const startCell = sheet.cell(rowNumber, startColumn);
                                            const endCell = sheet.cell(rowNumber, endColumn);
                                            const range = sheet.range(startCell, endCell);

                                            try {
                                                range.merged(true); // Merge the range
                                                range.style({
                                                    horizontalAlignment: "center", // Center horizontally
                                                    verticalAlignment: "center", // Center vertically
                                                    bold: true, // Optional: Make text bold
                                                    fontSize: 14, // Optional: Set font size
                                                });
                                                // console.log(`Merged cells in row ${rowNumber}, columns ${startColumn}-${endColumn}`);
                                            } catch (error) {
                                                // console.error(`Error merging cells in row ${rowNumber}, columns ${startColumn}-${endColumn}:`, error.message);
                                            }
                                        };

                                        const appendTextToRow = (rowNumber, columnNumber, textToAppend) => {
                                            const cell = sheet.cell(rowNumber, columnNumber);
                                            // console.log('cell=>', cell)
                                            // const currentValue = cell.value() || ""; // Get the current value, or empty if not set
                                            cell.value(textToAppend); // Append the new text
                                            // console.log('rowNumber, columnNumber=>', rowNumber, columnNumber)
                                        };


                                        newArray.forEach((row, rowIndex) => {
                                            // console.log(rowIndex, 'row=>', row)

                                            row.forEach((cell, colIndex) => {

                                                // console.log(rowIndex, 'row=>',colIndex, row)
                                                const cellRef = sheet.cell(rowIndex + 1, colIndex + 1);
                                                cellRef.value(cell);



                                                if (rowIndex === 0) {
                                                    cellRef.style({
                                                        bold: true,
                                                        italic: true,
                                                        fontSize: 20,
                                                        fill: 'FFFFFF',
                                                        horizontalAlignment: 'center',
                                                    });
                                                } else if (rowIndex >= 8) {
                                                    // console.log('rowIndex :', row[0])
                                                    //   console.log('rowIndex :', row[0] + moment(row[5]).format("DDMMYYYY"))
                                                    const colLetterStart = getColumnLetter(colIndex);
                                                    // sheet.cell(`${colLetterStart}${rowIndex}`).value(`${dayName}, ${formattedDate}`);
                                                    sheet.cell(`${colLetterStart}${rowIndex}`).value();







                                                    //  console.log('cell :',cell)
                                                } else if (rowIndex === 2 || rowIndex === 4 || rowIndex === 5) {
                                                    cellRef.style({
                                                        bold: true,
                                                        italic: true,
                                                        fill: 'FFFFFF',
                                                    });
                                                }
                                                else if (rowIndex === 7) {
                                                    cellRef.style({
                                                        bold: true,
                                                        italic: true,
                                                        // fill: 'FFFFFF',
                                                    });
                                                }
                                                else if (rowIndex == 6) {

                                                    // console.log('colIndex=>',colIndex)
                                                    sheet.column(setcolumn).width(22);
                                                    setcolumn = setcolumn + 3
                                                    cellRef.style({
                                                        bold: true,
                                                        // italic: true,
                                                        // fontSize: 10,
                                                        // fill: 'FFFFFF',
                                                        // horizontalAlignment: 'center',
                                                    });

                                                    mergeCellsInRow(7, setcolumn, setcolumn + 2); // Merge A1:D1
                                                }
                                                // else if (rowIndex == 7) {
                                                //     console.log('setcolumnRow7=>', setcolumnRow7)
                                                //     setcolumnRow7 = setcolumnRow7 + 3
                                                //     appendTextToRow(8, setcolumnRow7, "InTime");
                                                //     // appendTextToRow(8, setcolumnRow7 + 1, "OutTime");
                                                //     // appendTextToRow(8, setcolumnRow7 + 2, "Total HRS");
                                                //     // setcolumnRow7 = setcolumnRow7+3
                                                //     // appendTextToRow(8, setcolumnRow7, "OutTime");
                                                //     // setcolumnRow7 = setcolumnRow7+3
                                                //     // setcolumnRow7 = setcolumnRow7+1
                                                // }

                                                // else if (rowIndex == 6) {
                                                //     mergeCellsInRow(6, 1, 3); // Merge A1:D1
                                                //     mergeCellsInRow(6, 4, 6); // Merge B2:E2
                                                //     mergeCellsInRow(6, 7, 9 ); // Merge A3:C3
                                                // }

                                                // else {
                                                //     cellRef.style({
                                                //         fill: 'FFFFFF',
                                                //     });
                                                // }
                                            });

                                        });



                                        // Merge header ranges
                                        sheet.range("A1:BS1").merged(true);
                                        sheet.range("A2:BS2").merged(true);
                                        sheet.range("A3:BS3").merged(true);
                                        sheet.range("A4:BS4").merged(true);
                                        sheet.range("A5:BS5").merged(true);
                                        sheet.range("A6:BS6").merged(true);

                                        sheet.column(1).width(22);
                                        sheet.column(2).width(20);
                                        sheet.column(3).width(30);
                                        sheet.column(4).width(22);
                                        sheet.column(5).width(22);
                                        sheet.column(6).width(22);
                                        // sheet.column(7).width(202);
                                        // sheet.column(8).width(220);

                                        return workbook.outputAsync();
                                    })
                                    .then((blob) => {
                                        const url = window.URL.createObjectURL(blob);
                                        const anchor = document.createElement('a');
                                        anchor.href = url;
                                        anchor.download = 'attendance.xlsx';
                                        anchor.click();
                                        window.URL.revokeObjectURL(url);
                                        setLoader(false)
                                    });

                            });
                        }
                    });
            }
        };

    }


    const [workingday, setWorkingday] = useState('')
    var totalBusinessDays = 0;
    function calcBusinessDays(start, end) {
        var start = new Date(start);
        var end = new Date(end);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        var current = new Date(start);
        current.setDate(current.getDate() + 1);
        var day;
        // loop through each day, checking
        while (current <= end) {
            day = current.getDay();
            if (day >= 1 && day <= 5) {
                ++totalBusinessDays;
            }
            current.setDate(current.getDate() + 1);
        }
        setWorkingday(totalBusinessDays)
    }
    // const getColumnLetter = (index) => {
    //     let letter = '';
    //     while (index >= 0) {
    //         letter = String.fromCharCode((index % 26) + 65) + letter;
    //         index = Math.floor(index / 26) - 1;
    //     }
    //     return letter;
    // };

    const getColumnLetter = (index) => {
        let letter = '';
        index++; // Adjust for 1-based index (A = 1, B = 2, ..., Z = 26)
        while (index > 0) {
            index--; // Convert to 0-based index
            letter = String.fromCharCode((index % 26) + 65) + letter;
            index = Math.floor(index / 26);
        }
        return letter;
    };

    return (
        <div className='row'>
            <div className='col-md-3'>
                <div className='form-blk mb25'>
                    <div className='form-label'>Employee Type Reports</div>
                    <div className='form-input'>
                        <select className="form-select" onChange={(e) => HandleReportType(e.target.value)}>
                            <option value='1'>Individual Employee Reports</option>
                            <option value='2'>All Employee Reports</option>
                            <option value='3'>Custom Reports</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className={`col-md-3 mb25 ${reportType == 3 ? 'd-inline' : 'd-none'}`}>
                <div className='form-blk'>
                    <div className='form-label'>From Date</div>
                    <div className='form-input'>
                        <input onChange={e => setFromdate(e.target.value)} type="date" className="form-control" value={fromdate} placeholder="Select From Date" />
                    </div>
                </div>
            </div>
            <div className={`col-md-3 mb25 ${reportType == 3 ? 'd-inline' : 'd-none'}`}>
                <div className='form-blk'>
                    <div className='form-label'>To Date</div>
                    <div className='form-input'>
                        <input type="date" onChange={e => setTodate(e.target.value)} className="form-control" value={todate} placeholder="Select To Date" />
                    </div>
                </div>
            </div>
            <div className={`col-md-3 mb25 ${reportType == 3 ? 'd-inline' : 'd-none'}`}>
                <div className='form-blk'>
                    <label className="h22"></label>
                    <div className='form-input'>
                        <button className="btn_5"
                            onClick={Download_attendance_report} disabled={loader} >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}Download</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EmpAttendanceReport
